<template>
  <div class="tw-w-modal">
    <div class="tw-border-b tw-border-border-light tw-p-6">
      <h2 class="tw-text-xl tw-font-bold tw-text-black">
        Do you really want to resume this {{ entity.singular.toLowerCase() }}?
      </h2>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-p-6">
      <PassportButton
        variant="basic"
        label="Cancel"
        @@click="$emit('close')"
      />
      <PassportButton
        variant="primary"
        :busy="isLoading"
        :label="shouldRetry ? 'Retry' : 'Resume'"
        type="button"
        @@click="handleSubmit"
      />
    </div>
  </div>
</template>
<script>
import PassportButton from '@/components/PassportButton.vue'

export default {
  components: { PassportButton },
  name: 'PopupEntityResume',
  props: {
    entity: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    resolved: {
      type: Function,
      default: null,
    },
  },
  emits: ['close'],
  data() {
    return {
      isLoading: false,
      shouldRetry: false,
    }
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true
      this.shouldRetry = false

      try {
        await this.$store.dispatch(`${this.entity.module}/resume`, {
          id: this.item.id,
        })

        this.$store.dispatch('addToast', {
          type: 'info',
          value: `${this.entity.singular} ${
            this.item.id || this.item.id
          } successfully resumed`,
        })
        this.$store.dispatch(`${this.entity.module}/fetch`, {
          id: this.item.id,
          reload: true,
        })
        if (typeof this.resolved === 'function') {
          await this.resolved()
        }

        this.$emit('close')
      } catch (error) {
        this.shouldRetry = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
